export const TEST_ID_ATTR_NAME = 'data-test-id';
export const ENVIRONMENT_WHITELIST = ['development', 'test'];
export const MESSAGES = {
  testIdExistsAlready:
    'Test identifier "${value}" exists in ${vueComponentName} already. If this is intended use the "ignore" modifier like: v-test-id.ignore="\'${value}\'"',
};
